import * as React from 'react';

import {Button} from 'shells/button/button';
import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';

type Props = {
    campaign: any;
    onPublish: (campaignId: string) => Promise<any>;
};

export function PublishTemplateButton(props: Props) {
    const [shouldShowPublishConfirmation, setShouldShowPublishConfirmation] =
        React.useState<boolean>(false);

    const publishStatus = props.campaign.status;

    return (
        <>
            <Button
                variant='primary'
                size='big'
                onClick={() => {
                    setShouldShowPublishConfirmation(true);
                }}
            >
                {publishStatus === 'DRAFT' ? 'Publish template' : 'Unpublish template'}
            </Button>
            {shouldShowPublishConfirmation ? (
                <ConfirmationDialog
                    title={`${
                        publishStatus === 'DRAFT' ? 'Publish to' : 'Unpublish for'
                    } all users?`}
                    message={`${
                        publishStatus === 'DRAFT'
                            ? 'Publishing this template will make it available for all users. You can still make changes, or unpublish at any time.'
                            : 'Unpublishing this template will hide it from all users. You can still make changes, or republish at any time.'
                    }`}
                    confirmText={`Yes, ${
                        publishStatus === 'DRAFT' ? 'publish' : 'unpublish'
                    } template`}
                    isConfirmDestructive={false}
                    autoFocusCancelButton={false}
                    onCancel={() => setShouldShowPublishConfirmation(false)}
                    // isSaving={isToggleLoading}
                    onConfirm={() => {
                        props.onPublish(props.campaign.id).then(() => {
                            setShouldShowPublishConfirmation(false);
                        });
                    }}
                />
            ) : undefined}
        </>
    );
}
